import { defineMessages } from 'react-intl';

export default defineMessages({
  diffMode: {
    id: 'frontbucket.repository.source.fileModeSelector.diffMode',
    description: 'Label for the file mode when viewing a diff of a file',
    defaultMessage: 'Diff',
  },
  historyMode: {
    id: 'frontbucket.repository.source.fileModeSelector.historyMode',
    description:
      'Label for the file mode when viewing the commit history of a file',
    defaultMessage: 'History',
  },
  sourceMode: {
    id: 'frontbucket.repository.source.fileModeSelector.sourceMode',
    description:
      'Label for the file mode when viewing the source code of a file',
    defaultMessage: 'Source',
  },
});
